module.exports = __webpack_public_path__ + "img/favicon.3693962b.png";